import { lazy } from 'react';

export const RoleList = lazy(() => import('./page-list'));


